export enum SkeletonAppearanceEnum {
  default = '',
  line = 'line',
  circle = 'circle',
  square = 'square',
  media = 'media',
  heading = 'heading'
}

export enum SkeletonAnimationEnum {
  progress = 'progress',
  progressDark = 'progress-dark',
  pulse = 'pulse',
  default = ''
}
